import styled from "styled-components";

const BaseSection = styled.section`
  // ... (your existing styles)
  ${({ $right }) =>
    $right &&
    `
    // Add your right-side specific styles here
    margin-left: auto;
  `}
`;

export const Section = ({ children, right, ...props }) => {
  return (
    <BaseSection $right={right} {...props}>
      {children}
    </BaseSection>
  );
};
